<template>
     <div class="subscribe">

                        <h2> Are you traveling to Mexico and want to get tips on security?</h2>
                        <p> Sign up and receive more information. </p>

                        <div class="formaSubscribe">

                            <form class="forma" action="">
                                <input class="campoSubscribe" type="text" placeholder="Your email">
                                <span class="btnSubscribe">subscribe</span>

                            </form>

                        </div>
                    </div>

</template>

<script>
export default {
  name: "SubscribeComponent"
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
@import url("../assets/less/soloVariables.less");

.subscribe {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;

  position: relative;
  //top: 50px;
  width: 100%;
  //height: 280px;
  //padding-top: 10px;
  padding-bottom: 60px;
  text-align: center;
  background-color: @color_Principal_Logo;

  h2 {
    font-size: 1.9em;
    line-height: 1.5em;
    width: 60%;
    font-weight: bold;
    //border: 2px solid white;
    
  }
  p {
      width: 20%;
    font-weight: 300;
    font-size: 1.3em;
    padding-bottom: 15px;
    //border: 2px solid white;
     @media (max-width: @limiteAnchoTablet) {
        width: 60%;
     }
  }

  .formaSubscribe {
    display: flex;
    flex-direction: column;
    padding: 10px 40px;
    //border: 2px solid white;
    .forma {
      .campoSubscribe {
        padding: 5px;
        width: 200px;
        height: 30px;
        border-radius: 2px;
        color: gray;
        border: 0;
         @media (max-width: @limiteAnchoTablet) {
              width: 100px;
              height: 25px;
         }
         

        ::placeholder {
          color: @color_Secundario_Logo;
          opacity: 1; /* Firefox */
        }

        :-ms-input-placeholder {
          /* Internet Explorer 10-11 */
          color: @color_Secundario_Logo;
        }

        ::-ms-input-placeholder {
          /* Microsoft Edge */
          color: @color_Secundario_Logo;
        }
        //margin-right: 5px;
      }
      .btnSubscribe {
        cursor: pointer;
        margin-left: 5px;
        font-size: 0.8em;
        padding: 13px 30px;
        text-transform: uppercase;
        border-radius: 2px;
        background-color: @color_Secundario_Logo;
        &:hover{
            background-color: lighten(@color_Secundario_Logo, 5);
            transition: background-color .3s ease-in;
        }
        @media (max-width: @limiteAnchoTablet) {
               padding: 10px 10px;
         }
        
      }
    }
  }
}
</style>
